if (!customElements.get('header-menu')) {
  class HeaderMenu extends HTMLElement {
      constructor() {
          super();
      }

      connectedCallback() {
          this.addDelegatedEventListeners();
      }

      addDelegatedEventListeners() {
          this.addEventListener('click', (e) => {
              const clickedElement = e.target.closest('[data-action]');
              if (!clickedElement) return;

              const mobileDrawer = this.querySelector('[data-mobile-drawer]');
              const {
                  action,
                  submenu
              } = clickedElement.dataset;
              
              switch (action) {
                  case 'close-all-menus':
                      [...this.querySelectorAll('[data-mobile-drawer-submenu]')].forEach((x) => x.classList.add('translate-x-full'));
                      document.querySelector('[data-action="open-menu"]').focus();
                      break;
                  case 'close-menu':
                      mobileDrawer.classList.add('-translate-x-full');
                      document.querySelector('[data-action="open-menu"]').focus();
                      break;
                  case 'close-submenu':
                      if (!submenu) return;
                      this.querySelector(`[data-mobile-drawer-submenu="${submenu}"]`)?.classList.add('translate-x-full');
                      this.querySelector(`[data-action="open-submenu"][data-submenu="${submenu}"]`).focus();
                      this.querySelector(`[data-action="open-submenu"][data-submenu="${submenu}"]`).ariaExpanded = "false";
                      mobileDrawer.classList.remove('-translate-x-full');
                      break;
                  case 'open-menu':
                      mobileDrawer.classList.remove('-translate-x-full');
                      mobileDrawer.querySelector('[data-action="close-menu"]').focus();
                      break;
                  case 'open-submenu':
                      if (!submenu) return;
                      this.querySelector(`[data-mobile-drawer-submenu="${submenu}"]`)?.classList.remove('translate-x-full');
                      this.querySelector(`[data-mobile-drawer-submenu="${submenu}"] [data-action="close-submenu"]`).focus();
                      clickedElement.ariaExpanded = "true";
                      mobileDrawer.classList.add('-translate-x-full');
                      break;
                  default: break;
              }
          })

          //ADA Keyboard/Mouse
          this.activeDropdown = this.activeDropdown || null;

          const closeActiveDropdown = () => {
            if (!this.activeDropdown) return;
            const { menu, trigger } = this.activeDropdown;

            trigger.setAttribute('aria-expanded', 'false');
            menu.classList.remove('w-full', 'opacity-100');
            menu.setAttribute('inert', '');

            this.activeDropdown = null;
          };

          if (!this._escapeListenerBound) {
            this._escapeListenerBound = true;
            document.addEventListener('keydown', (e) => {
              if (e.key !== 'Escape') return;
              if (!this.activeDropdown) return;

              e.preventDefault();
              const { trigger } = this.activeDropdown;
              closeActiveDropdown();
              trigger.focus();
            }, true);
          }

          this.querySelectorAll('[data-action="dropdown"]').forEach(el => {
            let menu = el.querySelector('[data-overlay-sibling]');
            let trigger = el.querySelector('button[aria-expanded]');

            if (!menu || !trigger) return;

            const isOpen = () => {
              return menu.classList.contains('w-full') || menu.classList.contains('opacity-100');
            };

            const openMenu = () => {
              // close any other currently-open dropdown first
              if (this.activeDropdown && this.activeDropdown.menu !== menu) {
                closeActiveDropdown();
              }

              trigger.setAttribute('aria-expanded', 'true');
              menu.classList.add('w-full', 'opacity-100');
              menu.removeAttribute('inert');

              this.activeDropdown = { menu, trigger };
            };

            const closeMenu = () => {
              trigger.setAttribute('aria-expanded', 'false');
              menu.classList.remove('w-full', 'opacity-100');
              menu.setAttribute('inert', '');

              if (this.activeDropdown && this.activeDropdown.menu === menu) {
                this.activeDropdown = null;
              }
            };

            el.addEventListener('mouseenter', () => {
              openMenu();
            });

            el.addEventListener('mouseleave', () => {
              closeMenu();
            });

            // Only open/close via keyboard on the trigger (Enter/Space)
            trigger.addEventListener('keydown', (e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                if (isOpen()) {
                  closeMenu();
                } else {
                  openMenu();
                }
              }
            });

            // Close when focus leaves the entire dropdown <li>
            el.addEventListener('focusout', (e) => {
              if (!el.contains(e.relatedTarget)) {
                closeMenu();
              }
            });
          })

          if (this.closest('.banner')) {
              window.addEventListener('scroll', () => {
                  if (window.pageYOffset > this.offsetHeight) {
                      document.documentElement.style.setProperty('--count-text', 'var(--primary-light)');
                      document.documentElement.style.setProperty('--header-text', 'var(--primary-dark)');
                      document.documentElement.style.setProperty('--header-bg', 'var(--header-bg-initial)');
                      document.documentElement.style.setProperty('--header-shadow', '0 2px 4px 0 rgb(0 0 0 / 2%), 0 2px 10px 0 rgb(0 0 0 / 3%)');
                      this.querySelector('nav')?.classList.replace('before:backdrop-blur-none', 'before:backdrop-blur-xl');
                      return;
                  }
                  document.documentElement.style.setProperty('--count-text', 'var(--accent-1)');
                  document.documentElement.style.setProperty('--header-text', 'var(--primary-light)');
                  document.documentElement.style.setProperty('--header-bg', 'transparent');
                  document.documentElement.style.setProperty('--header-shadow', '0');
                  this.querySelector('nav')?.classList.replace('before:backdrop-blur-xl', 'before:backdrop-blur-none');

              }, { passive: true })
              this.addEventListener('mouseenter', () => {
                  if (window.matchMedia('(min-width: 768px)')) return;
                  document.documentElement.style.setProperty('--count-text', 'var(--primary-light)');
              });
              this.addEventListener('mouseleave', () => {
                  if (window.pageYOffset > this.offsetHeight) {
                      if (window.matchMedia('(min-width: 768px)')) return;
                      document.documentElement.style.setProperty('--count-text', 'var(--primary-light)');
                      return;
                  }
                  document.documentElement.style.setProperty('--count-text', 'var(--accent-1)');
              })
          } else {
              window.addEventListener('scroll', () => {
                  if (window.pageYOffset > 0) {
                      document.documentElement.style.setProperty('--header-shadow', '0 2px 4px 0 rgb(0 0 0 / 2%), 0 2px 10px 0 rgb(0 0 0 / 3%)');
                      this.querySelector('nav')?.classList.replace('before:backdrop-blur-none', 'before:backdrop-blur-xl');
                  } else {
                      document.documentElement.style.setProperty('--header-shadow', '0');
                      this.querySelector('nav')?.classList.replace('before:backdrop-blur-xl', 'before:backdrop-blur-none');
                  }
              })
          }
      }
  }

customElements.define('header-menu', HeaderMenu);
}